import React from 'react';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default [
  <DefaultConsumerLayout
    key="/consumer/features/reshape-face-in-video"
    exact
    path="/consumer/features/reshape-face-in-video"
    component={AsyncPage}
  />,
];
